import { render, staticRenderFns } from "./AddOutOfStockEmail.vue?vue&type=template&id=2dda7c6f"
import script from "./AddOutOfStockEmail.vue?vue&type=script&lang=js"
export * from "./AddOutOfStockEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports